import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Axios from 'axios';
import {ACCOUNT_PRODUCT_UPDATE } from '../../../../../config/rest_endpoints';
import { getUser } from '../../../../../actions/session';
import { Notifications } from '../../../../common/notification';
import { RC_LOAD_LOGIN } from '../../../../routers/RouteConstants'
import Switch from "react-switch";


const CreateBilling = (props) => {
    const {userId, previousValue,listRefresh,close} = props
    const [isLoader, setisLoader] = useState(false)
    const [isActive, setisActive] = useState(true)
    const [userInfo] = useState(getUser())
    const [state, setState] = useState({
        description: '',
        amount: '',
        units: '',
    })
    const [selectCategory, setSelectCategory] = useState('')
    const [categoryOption] = useState([
        //{ label: 'Local Number', value: 'Local Number' },
        //{ label: 'Toll Free Number', value: 'Toll Free Number' },
        //{ label: 'Local Minutes _inbound', value: 'Local Minutes _inbound' },
        //{ label: 'Toll Free Minutes _inbound', value: 'Toll Free Minutes _inbound' },
        { label: 'Server Hosting', value: 'Server Hosting' },
       // { label: 'Contact Center Station', value: 'Contact Center Station' },
        { label: 'Taxes and Other Fees', value: 'Taxes and Other Fees' },
    ])
    const [selectMethod, setSelectMethod] = useState('')
    const [methodOption] = useState([
        { label: 'Unit', value: 'Unit' },
        { label: 'Minute', value: 'Minute' },
        { label: 'Billed Usage', value: 'Billed Usage' },
        //{ label: 'Per Completed Call', value: 'Per Completed Call' },
        //{ label: 'Per Call Attempt', value: 'Per Call Attempt' },
    ])
    const [selectFrequency, setSelectFrequency] = useState('')
    const [frequencyOption] = useState([
        { label: 'Daily', value: 'Daily' },
        { label: 'Weekly', value: 'Weekly' },
        //{ label: 'Biweekly', value: 'Biweekly' },
        //{ label: 'Monthly', value: 'Monthly' },
    ])
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())

    const handleInput = (e) => {
        const {name, value} = e.target
        setState(prev => ({
            ...prev,
            [name]:value
        }))
    }

    useEffect(()=> {
        getPreviousValue()
    },[previousValue])

    const getPreviousValue = () => {
        setState({
            description: previousValue.description,
            amount: previousValue.amount,
            units: previousValue.units,
        })
        setSelectCategory({ label: previousValue.category, value: previousValue.category })
        setSelectMethod({ label: previousValue.method, value:  previousValue.method })
        setSelectFrequency({ label: previousValue.frequency, value:  previousValue.frequency })
        setisActive(previousValue.active)
    }

    const handleCategory = (selectCategory) => {
        setSelectCategory(selectCategory)
    }

    const handleMethod = (selectMethod) => {
        setSelectMethod(selectMethod)
    }

    const handleFrequency = (selectFrequency) => {
        setSelectFrequency(selectFrequency)
    }

    const handleStartDate = (startDate) => {
        setStartDate(startDate)
    }

    const handleEndDate = (endDate) => {
        setEndDate(endDate)
    }

    const handleStatus = () => {
        setisActive(!isActive)
    }

    const submitBilling = () => {
        setisLoader(true)
        const payload = {
            "accountID": userId,
            "category": selectCategory.value,
            "description": state.description,
            "method": selectMethod.value,
            "amount": state.amount,
            "units": state.units,
            "frequency": selectFrequency.value,
            "startDate": startDate,
            "endDate": endDate,
            "id":previousValue.id,
            "active":isActive,
            "forBack": "Backword",
            "generateInvoice": "CustomerTerms"
        }
        var headers = { "Authorization": "Bearer " + userInfo.token };
        Axios.put(`${ACCOUNT_PRODUCT_UPDATE}`,payload, { headers }).then(res => {
            if (res) {
                console.log(`res`, res)
                setisLoader(false)
                listRefresh()
                close()
            }
        }).catch(err => {
            const alert = err.response
            if (alert.data.message === 'invalid or expired jwt') {
                setisLoader(false)
                localStorage.removeItem('user');
                props.history.push(RC_LOAD_LOGIN)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            setisLoader(false)
        })
    }

    return (
        <div className="row">
            {/* <div className="col-md-6">*/}
            {/*    <div class="form-group">*/}
            {/*        <label className="fs-14">Start Date</label>*/}
            {/*        <div class="input-group">*/}
            {/*            <DatePicker*/}
            {/*                selected={startDate}*/}
            {/*                onChange={handleStartDate}*/}
            {/*                showTimeSelect*/}
            {/*                timeFormat="HH:mm:ss"*/}
            {/*                timeIntervals={15}*/}
            {/*                timeCaption="time"*/}
            {/*                dateFormat="MMMM d, yyyy h:mm:ss aa"*/}
            {/*                className="reporting-theme-date w-27em"*/}
            {/*                isClearable*/}
            {/*                placeholderText="Start Date"*/}
            {/*            >*/}
            {/*            </DatePicker>*/}

            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className="col-md-6">*/}
            {/*    <div class="form-group">*/}
            {/*        <label className="fs-14">End Date</label>*/}
            {/*        <div class="input-group">*/}
            {/*            <DatePicker*/}
            {/*                selected={endDate}*/}
            {/*                onChange={handleEndDate}*/}
            {/*                showTimeSelect*/}
            {/*                timeFormat="HH:mm:ss"*/}
            {/*                timeIntervals={15}*/}
            {/*                timeCaption="time"*/}
            {/*                dateFormat="MMMM d, yyyy h:mm:ss aa"*/}
            {/*                className="reporting-theme-date w-27em"*/}
            {/*                isClearable*/}
            {/*                placeholderText="Start Date"*/}
            {/*            >*/}
            {/*            </DatePicker>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className="col-md-4">
                <div className="form-group">
                    <label style={{fontWeight:'400',fontSize:'16px'}}>Category</label>
                    <Select
                        value={selectCategory}
                        onChange={handleCategory}
                        options={categoryOption}
                    />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label style={{fontWeight:'400',fontSize:'16px'}}>Method</label>
                    <Select
                        value={selectMethod}
                        onChange={handleMethod}
                        options={methodOption}
                    />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label style={{fontWeight:'400',fontSize:'16px'}}>Frequency</label>
                    <Select
                        value={selectFrequency}
                        onChange={handleFrequency}
                        options={frequencyOption}
                    />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label style={{fontWeight:'400',fontSize:'16px'}}>Description</label>
                    <input type="text" className="form-control" name="description" value={state.description} onChange={handleInput} placeholder="Enter description" />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label style={{fontWeight:'400',fontSize:'16px'}}>Amount</label>
                    <input type="text" className="form-control" name="amount" value={state.amount} onChange={handleInput} placeholder="Enter description" />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label style={{fontWeight:'400',fontSize:'16px'}}>Unit</label>
                    <input type="text" className="form-control" name="units" value={state.units} onChange={handleInput} placeholder="Enter description" />
                </div>
            </div>
            <div className="col-md-4">
            <div className="form-group mt-1">
                    <div className="row">
                        <div className="col-md-3 mt-1">
                            <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14" >Status</label>
                        </div>
                        <div className="col-md-1 mr-3">
                            <Switch onChange={handleStatus} checked={isActive} />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{borderTop:'1px solid #e9ecef'}} className="col-md-6 ml-auto">
                <button type="submit " className="mt-2 btn btn-primary float-right" disabled={isLoader ? true : false} onClick={submitBilling} >
                    Update Billing {isLoader ? <i class="fas fa-spinner fa-spin ml-1"></i> : <i class="icon-file-plus ml-1 icon-1x"></i> } 
                </button>
            </div>
        </div>
    )
}

export default CreateBilling